<template>
	<PopUp
		title="Wunsch-Job veröffentlichen"
		size="lg"
		ok-text="Jetzt veröffentlichen"
		:hide-ok="!publishable"
		:hide-cancel="publishing"
		:cancel-text="publishable ? 'Abbrechen' : 'Schließen'"
		:ok-disabled="publishing"
		:ok-loading="publishing"
		@ok="publish"
		@hidden="$emit('hidden')"
	>
		<!--<div class="d-flex align-items-center">
			<div class="mr-4">
				<Icon
					:icon="publishableChecklist.sectionCompletions ? 'check-circle' : 'cross-circle'"
					:color="publishableChecklist.sectionCompletions ? 'green' : 'red'"
					size="2x"
				/>
			</div>
			<div>
				<div class="font-weight-extra-bold">Wunsch-Job</div>
				<div v-if="!publishableChecklist.sectionCompletions" class="mt-2">
					Dein Wunsch-Job ist noch nicht vollständig.
				</div>
			</div>
		</div>
		<div class="d-flex align-items-center mt-3">
			<div class="mr-4">
				<Icon
					:icon="publishableChecklist.skills ? 'check-circle' : 'cross-circle'"
					:color="publishableChecklist.skills ? 'green' : 'red'"
					size="2x"
				/>
			</div>
			<div>
				<div class="font-weight-extra-bold">Meine Kompetenzen</div>
				<div v-if="!publishableChecklist.skills" class="mt-2">
					Du hast noch nicht alle deine Kompetenzen angegeben. Bitte vervollständige diese unter
					<a href="/kandidat/profil/kompetenzen">Meine Kompetenzen</a>.
				</div>
			</div>
		</div>
		<div class="d-flex align-items-center mt-3">
			<div class="mr-4">
				<Icon
					:icon="publishableChecklist.legitimation ? 'check-circle' : 'cross-circle'"
					:color="publishableChecklist.legitimation ? 'green' : 'red'"
					size="2x"
				/>
			</div>
			<div>
				<div class="font-weight-extra-bold">Mobilnummer bestätigt</div>
				<div v-if="!publishableChecklist.legitimation" class="mt-2">
					Du hast deinen Account noch nicht vollständig legitimiert. Bitte erledige das unter
					<a href="/kandidat/profil/sicherheit">Daten und Sicherheit</a>.
				</div>
			</div>
		</div>-->
		<div v-if="publishable">
			Nach Veröffentlichung scheint dein Wunsch-Job auch für Firmen auf um dich kontaktieren zu können.
		</div>
	</PopUp>
</template>

<script>
import PopUp from "@/vue/common/PopUp"
import Icon from "@/vue/icon/Icon";
import Change, { ACTION_PUBLISH } from "@/api/application/job/status/Change";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import * as Event from "@/helper/tracking/Event";
import EventData from "@/helper/tracking/EventData";

export default {

	components: {
		PopUp,
		Icon,
	},

	props: {
		job: {
			type: Object,
			required: true,
		},
	},

	data ()
	{
		return {
			publishing: false,
		};
	},

	computed: {
		publishableChecklist ()
		{
			return this.job.publishableChecklist;
		},
		publishable ()
		{
			return this.publishableChecklist.overall;
		}
	},

	methods: {
		async publish ()
		{
			Event.push(
				new EventData()
					.setEvent(Event.APPLICANT_JOB)
					.setAction('Veröffentlichen')
					.setName(this.job.name)
			);

			this.publishing = true;

			try
			{
				await new Change()
					.setJobId(this.job.id)
					.setAction(ACTION_PUBLISH)
					.call();

				this.$emit('publish');
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.publishing = false;
		}
	}
}
</script>
